<button type="button" class="btn btn-primary" genPermissionSchemaRestrict [permissionSchemaKey]="'testSpecimenWrite'"
        (click)="openPopup()">+ Accession Specimen</button>
